// eslint-disable-next-line import/no-cycle
import { AZLogTenant } from './LoggingSupport';
import LogLevel from '../../../logging/LogLevel';
const LogModule = {
    error(tenantId, message, optionalParams) {
        AZLogTenant(LogLevel.Error, message, tenantId, optionalParams);
    },
    warn(tenantId, message, optionalParams) {
        AZLogTenant(LogLevel.Warn, message, tenantId, optionalParams);
    },
    info(tenantId, message, optionalParams) {
        AZLogTenant(LogLevel.Info, message, tenantId, optionalParams);
    },
    debug(tenantId, message, optionalParams) {
        AZLogTenant(LogLevel.Debug, message, tenantId, optionalParams);
    },
};
export default LogModule;
//# sourceMappingURL=LogModule.js.map